import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useMemo } from 'react';
import { CustomerContext } from '.';
export const CustomerContextProvider = ({ children }) => {
    const [customer, setCustomer] = useState(undefined);
    const [customerRequired, setCustomerRequired] = useState(false);
    return _jsx(CustomerContext.Provider, { value: useMemo(() => ({ customer, setCustomer, customerRequired, setCustomerRequired }), [customer, setCustomer, customerRequired, setCustomerRequired]), children: children });
};
